import React, { useState } from "react";
import { toast } from "sonner";
import { uploadFileChunked, fileUrl } from "@/lib/api";
import { ImagePlus, X, UploadCloud } from "lucide-react";

export default function PortadaUploader({ value, onChange, testid = "portada", label = "Portada" }) {
  const [pct, setPct] = useState(null);
  const [over, setOver] = useState(false);

  const doUpload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Debe ser una imagen"); return; }
    setPct(0);
    try {
      const res = await uploadFileChunked(file, setPct);
      onChange(res.url);
      toast.success("Portada subida ✓");
    } catch { toast.error("Error al subir la portada"); }
    finally { setPct(null); }
  };

  const onDrop = (e) => {
    e.preventDefault(); setOver(false);
    const file = e.dataTransfer?.files?.[0];
    doUpload(file);
  };

  return (
    <div className="field" style={{ margin: 0 }}>
      <label>{label} — arrastra una imagen aquí o haz clic para subir</label>
      <div
        data-testid={testid}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={onDrop}
        style={{
          position: "relative", borderRadius: 12, overflow: "hidden",
          border: `1.5px dashed ${over ? "var(--gold)" : "var(--line)"}`,
          background: over ? "rgba(197,164,90,.10)" : "rgba(255,255,255,.02)",
          minHeight: value ? 0 : 120, display: "flex", alignItems: "center", justifyContent: "center",
          transition: "border-color .2s, background .2s",
        }}
      >
        {value ? (
          <>
            <img src={fileUrl(value)} alt="portada" data-testid={`${testid}-img`} style={{ width: "100%", maxHeight: 220, objectFit: "cover", display: "block" }} />
            <button type="button" className="abtn danger" data-testid={`${testid}-remove`} onClick={() => onChange("")}
              style={{ position: "absolute", top: 8, right: 8 }}><X size={14} /></button>
            <label style={{ position: "absolute", bottom: 8, right: 8, cursor: pct != null ? "wait" : "pointer" }} className="abtn" data-testid={`${testid}-replace`}>
              <UploadCloud size={13} /> {pct == null ? "Cambiar" : `${pct}%`}
              <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => { doUpload(e.target.files?.[0]); e.target.value = ""; }} disabled={pct != null} />
            </label>
          </>
        ) : (
          <label style={{ cursor: pct != null ? "wait" : "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 8, color: "var(--muted)", padding: "20px 12px", width: "100%" }}>
            <ImagePlus size={26} />
            <span style={{ fontSize: 13 }}>{pct == null ? "Subir o arrastrar imagen de portada" : `Subiendo… ${pct}%`}</span>
            <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => { doUpload(e.target.files?.[0]); e.target.value = ""; }} disabled={pct != null} />
          </label>
        )}
      </div>
    </div>
  );
}
